import * as React from "react";
function SvgBag(props, svgRef) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M19.1 6.17705H15.3V5.72304C15.3 3.66699 13.5985 2 11.5 2C9.40145 2 7.7 3.66699 7.7 5.72304V6.17705H3.9L2 22H21L19.1 6.17705ZM8.65 5.72304C8.65 4.18356 9.9287 2.93076 11.5 2.93076C13.0713 2.93076 14.35 4.18356 14.35 5.72304V6.17705H8.65V5.72304ZM4.13655 20.1385L5.5891 8.03857H7.7V9.43471C7.7 9.6916 7.9128 9.90009 8.175 9.90009C8.4372 9.90009 8.65 9.6916 8.65 9.43471V8.03857H14.35V9.43471C14.35 9.6916 14.5628 9.90009 14.825 9.90009C15.0872 9.90009 15.3 9.6916 15.3 9.43471V8.03857H17.4109L18.8635 20.1385H4.13655Z" style={{
      fill: "var(--svg-color, var(--default-svg-color, #000))"
    }} /></svg>;
}
const ForwardRef = React.forwardRef(SvgBag);
export default __webpack_public_path__ + "src/assets/icons/bag.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/bag_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/bag_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/bag_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/bag_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/bag_4x.svg"
};
export { ForwardRef as ReactComponent };